import { VisibilityConfig } from '../..'

export const DEFAULT_TRACKING_CONFIG: VisibilityConfig = {
  threshold: 0.7,
  duration: { visible: 500 },
}
